import React from "react";
import { Box, Typography, Link, SvgIcon, SvgIconProps } from "@mui/material";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import companyDetailsConfig from "../company-details-config";

const TikTokIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <path
      fill="currentColor"
      d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48"
    />
  </SvgIcon>
);

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Box
      sx={{
        backgroundImage: "linear-gradient(90deg, #E7BAD1 0%, #7FBEEB 100%)",
        padding: "10px",
        overflow: "hidden",
        boxShadow: "0 -4px 8px rgba(0, 0, 0, 0.1)", // Shadow effect above the footer
        bottom: 0, // Align it at the bottom of the window
        left: 0, // Stretch to the left edge
        right: 0, // Stretch to the right edge
        zIndex: 1000, // High z-index to ensure it sits above content
      }}
    >
      {/* Watermark Text */}
      <Typography
        variant="h4"
        sx={{
          position: "absolute",
          left: "50%",
          transform: "translate(-50%, 75%)",
          color: "#DBD8F0",
          zIndex: 0,
          pointerEvents: "none",
          whiteSpace: "nowrap",
          fontSize: "40px",
          opacity: {xs:0.2,sm:0.2,md:0.4},
        }}
      >
        COZY BUD
      </Typography>

      <Typography
        variant="h6"
        sx={{
          position: "absolute",
          left: "50%",
          transform: "translate(-50%, 50%)",
          color: "#DBD8F0",
          zIndex: 0,
          pointerEvents: "none",
          whiteSpace: "nowrap",
          fontSize: "20px",
          opacity: {xs:0.2,sm:0.2,md:0.4},
        }}
      >
        Let us make your bud cozy
      </Typography>

      {/* Contact Information */}
      <Typography
        variant="body2"
        sx={{ textAlign: "left", padding: "2px", fontSize: { xs:"12px",sm:"12px",md:"14px"} }}
      >
        Contact us:
      </Typography>

      <Typography variant="body2" sx={{ textAlign: "left", fontSize: { xs:"10px",sm:"10px",md:"14px"}, wordWrap: "break-word" }}>
        <span style={{ display: "flex", alignItems: "center", padding: "2px" }}>
          <BusinessOutlinedIcon
            sx={{
              verticalAlign: "middle",
              marginRight: "5px",
              fontSize: { xs:"12px",sm:"12px",md:"18px"},
            }}
          />
          {companyDetailsConfig.name},<br/>{companyDetailsConfig.addressLine1}<br/>{companyDetailsConfig.addressLine2}
        </span>
        <span style={{ display: "flex", alignItems: "center", padding: "2px" }}>
          <EmailOutlinedIcon
            sx={{
              verticalAlign: "middle",
              marginRight: "5px",
              fontSize: { xs:"12px",sm:"12px",md:"18px"},
            }}
          />
          {companyDetailsConfig.email}
        </span>
        <span style={{ display: "flex", alignItems: "center", padding: "2px" }}>
          <LocalPhoneOutlinedIcon
            sx={{
              verticalAlign: "middle",
              marginRight: "5px",
              fontSize: { xs:"12px",sm:"12px",md:"18px"},
            }}
          />
          {companyDetailsConfig.mobile}
        </span>
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          padding: "10px",
        }}
      >
        {/* Copyright Text in the Center */}
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs:"9px",sm:"9px",md:"12px"},
            opacity: { xs:0.3,sm:0.3,md:0.4 },
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          © {currentYear} Cozy Bud (Pvt) Ltd. All rights reserved.
        </Typography>

        {/* Social Icons on the Right */}
        <Box sx={{ display: "flex", position: "absolute", right: "10px" }}>
          <Link href={companyDetailsConfig.fbLink} target="_blank" sx={{ margin: "0 5px" }}>
            <FacebookOutlinedIcon sx={{ fontSize: { xs:"15px",sm:"15px",md:"25px"} }} />
          </Link>
          <Link href={companyDetailsConfig.tiktokLink} target="_blank" sx={{ margin: "0 5px" }}>
            <TikTokIcon sx={{ fontSize: { xs:"15px",sm:"15px",md:"25px"}, color: "#E7BAD1" }} />
          </Link>
          <Link href={companyDetailsConfig.instaLink} target="_blank" sx={{ margin: "0 5px" }}>
            <InstagramIcon sx={{ fontSize: { xs:"15px",sm:"15px",md:"25px"}}} />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
